// src/components/common/ReportMobileCard.js
import React from "react";
import { Card } from "react-bootstrap";

/**
 * Mobile card layout for weekly report metrics.
 * Shows: weekLabel + fechamento on top, 3 metric badges, lastEdit + action buttons.
 * @param {string} weekLabel - e.g. "10 Feb 2026"
 * @param {Object} metrics - from computeReportMetrics()
 * @param {string} lastEdit - formatted date or ""
 * @param {React.ReactNode} extraBadges - optional extra badges (e.g. salary)
 * @param {React.ReactNode} bottomContent - optional content below badges (e.g. expandable history)
 * @param {React.ReactNode} children - action buttons
 */
export default function ReportMobileCard({ weekLabel, metrics, lastEdit, extraBadges, bottomContent, children, onClick }) {
  return (
    <Card
      className="mb-2 shadow-sm"
      style={{ borderLeft: '3px solid #0d6efd', cursor: onClick ? 'pointer' : undefined }}
      onClick={(e) => { if (onClick && !e.target.closest('button')) onClick(); }}
    >
      <Card.Body className="py-2 px-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span className="fw-semibold">{weekLabel}</span>
          <span className="badge rounded-pill bg-success" style={{ fontSize: '0.9em', padding: '5px 10px' }}>
            {metrics.fechamentoTotal}
          </span>
        </div>
        <div className="d-flex gap-2 mb-2 flex-wrap">
          <span className="badge rounded-pill" style={{ backgroundColor: '#e7f1ff', color: '#0d6efd', fontSize: '0.8em' }}>
            Trab {metrics.totalWorked}
          </span>
          <span className="badge rounded-pill" style={{ backgroundColor: '#e0f7fa', color: '#0891b2', fontSize: '0.8em' }}>
            Lunch {metrics.totalLunch}
          </span>
          <span className="badge rounded-pill" style={{ backgroundColor: '#fff3e0', color: '#e65100', fontSize: '0.8em' }}>
            Traj {metrics.totalTravel}
          </span>
          {extraBadges}
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <small className="text-muted">{lastEdit}</small>
          <div className="d-flex gap-1">{children}</div>
        </div>
        {bottomContent}
      </Card.Body>
    </Card>
  );
}
